import * as React from 'react';
export const TableRow = ({ as = 'tr', children, ...rest }) => {
    return React.createElement(as, {
        role: as !== 'tr' ? 'row' : undefined,
        ...rest,
    }, children);
};
